// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//   const location = useLocation();

//   useEffect(() => {
//     // Ensure the page always starts at the top
//     window.scrollTo({ top: 0, left: 0, behavior: "instant" });
//   }, [location.pathname]); // Trigger on route change

//   return null;
// };

// export default ScrollToTop;
// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, [pathname]);

  return null;
}
